import React from 'react';
import {Button} from "antd";
import {Link} from "react-router-dom";
import styled from "styled-components";
import Logo from '../../../../media/icons/logo.svg?react';
import {useNavigate} from "react-router";
import {Route} from "../../../../config/acl/routes/Route";
import {pathFromRoute} from "../../../../utils/helpers/acl/pathFromRoute";
import {headerSharedLinks} from "../headerSharedLinks";
import {useIntl} from "react-intl";
import {useAppSelector} from "../../../../store/store";
import {groupNotGuest} from "../../../../config/acl/roles/groups";
import {lk} from "../../../../config/acl/routes/lk/lk";

const LK_BASE_PATH = '/lk';

const HeaderDesktopLeftStyled = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 13px;
  align-items: center;

  a {
    display: flex;
  }
`;



export const HeaderDesktopLeft = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const {isAuthenticated, role} = useAppSelector(state => state.auth);
  const showMyCabinet = isAuthenticated && groupNotGuest.includes(role);

  return (
    <HeaderDesktopLeftStyled>
      <Link to={pathFromRoute(Route.home)}>
        <Logo/>
      </Link>
      {headerSharedLinks.map(el =>
        <Button key={el.path} type={'text'} size={'middle'} onClick={() => navigate(el.path)} >
          <Link to={el.path}>{intl.formatMessage(el.title)} </Link>
        </Button>)
      }
      {showMyCabinet && (
        <Button type={'text'} size={'middle'} onClick={() => navigate(LK_BASE_PATH)}>
          <Link to={LK_BASE_PATH}>{intl.formatMessage(lk.title)}</Link>
        </Button>
      )}
    </HeaderDesktopLeftStyled>
  );
};

